import { languageMap } from ".."
import "./html"

languageMap.erb = languageMap.html
